var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAtom } from 'jotai';
import { loadingState } from '@/components/LoadingView';
import ToastUtils from '@/utils/ToastUtils';
export default function usePost(mutationKey, apiFn) {
    const queryClient = useQueryClient();
    const [loading, setLoading] = useAtom(loadingState);
    return useMutation({
        mutationKey: mutationKey,
        mutationFn: (params) => __awaiter(this, void 0, void 0, function* () { return yield apiFn(params); }),
        onSettled: () => setLoading(new Map(loading).set(mutationKey.join(','), false)),
        onMutate: () => setLoading(new Map(loading).set(mutationKey.join(','), true)),
        onError: error => {
            ToastUtils.showOnApiError(error);
        },
        onSuccess: _ => queryClient.invalidateQueries({
            queryKey: mutationKey,
        }),
    });
}
